const getDataByKey = ( keyword: string,props: detailTypes ) => {
    const keys = keyword.split( "." );
    const { globalData } = props;
    let value = ""
    try {
      keys.forEach(item => {
        if (item === void 0) throw new Error('Data undefind!')
        value = value ? value[item] : globalData[item]
      })
    } catch (error) {
      console.warn(`${error}: ${keyword}`)
    }
    return {
      [keys[keys.length - 1]]: value
    }
};

// 获取组件数据
const getModuleData = ( name: string,props: detailTypes ): object => {
    const { nodeMap,globalData } = props;
    const nodeData = nodeMap[name];
    if ( !nodeData ) return;
    const { globalDataKeys } = nodeData;
    let params = {
        i18n: globalData.i18n,
    };
    globalDataKeys.forEach( ( item: string ) => {
        params = Object.assign( params,getDataByKey( item,props ) );
    } );
    return params;
};

export { getModuleData };
